import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import EstagioService from "service/producao/EstagioService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const estagioService = new EstagioService();

export default function EstagioListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Estágios');

    const defaultFilters: DataTableFilterMeta = {
        codigoEstagio: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },

        nome: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={estagioService} urlService="/estagio" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="estagio">
            <Column 
                field="codigoEstagio" header="Código" 
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
            <Column 
                field="nome" header="Nome" 
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
        </BaseListagem>
    )
}